import * as React from 'react';
import { EDeviceType } from '../../types/device';
export var RootContext = /*#__PURE__*/React.createContext({
  deviceType: EDeviceType.Phone,
  disabledSocials: [],
  stepFlow: true,
  returnUrl: '',
  // NEW PROPS
  userAgent: '',
  showLogo: true,
  autoFocusDisabled: false,
  frameless: false
});